import angular from 'angular';


import DocumentPreviewController from './documentPreviewController';
import FileUploadController from './fileUploadController';
import UploadModalController from './uploadModalController';

import './documentChecklist.scss'; // no controller


export default angular.module('app.appDetail.documents.uploadDocuments', [])
    .controller('DocumentPreviewController', DocumentPreviewController)
    .controller('FileUploadController', FileUploadController)
    .controller('UploadModalController', UploadModalController)
    .run(($templateCache) => {
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/completionCertificateChecklistTemplate.html', require('./completionCertificateChecklistTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/documentDesignation.html', require('./documentDesignation.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/documentPreviewTemplate.html', require('./documentPreviewTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/fileUploadTemplate.html', require('./fileUploadTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/hicChecklistTemplate.html', require('./hicChecklistTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/invoiceChecklistTemplate.html', require('./invoiceChecklistTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/permitChecklistTemplate.html', require('./permitChecklistTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/solarLeaseAgreementChecklistTemplate.html', require('./solarLeaseAgreementChecklistTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/documents/uploadDocumentsModal/uploadModalTemplate.html', require('./uploadModalTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/uploadDocumentsModal/index.js